import React from "react";
import "./Tabs.scss";

export interface TabItem {
  key: string;
  label: string;
  count?: number;
}

interface TabsProps {
  items: TabItem[];
  activeKey: string;
  onChange: (key: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ items, activeKey, onChange }) => {
  return (
    <div className="tabs">
      {items.map((item) => (
        <button key={item.key} className={`tabs__item ${item.key === activeKey ? "tabs__item--active" : ""}`} onClick={() => onChange(item.key)}>
          {item.label}
          {item.count !== undefined && <span className={`tabs__count ${item.key === activeKey ? "tabs__count--active" : ""}`}>{item.count}</span>}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
